/*
  Blend Match Quiz - configuration (v2, 5 questions).
  Loaded before assets/hm-quiz-engine.js by sections/hm-quiz.liquid.

  This is a PRODUCT MATCH quiz: the four dimensions are the four blends,
  answers add fit points to each, and the strongest normalized fit wins.
  The page hides the score readout and bars (show_score off in the
  template) and the engine swaps the results CTA to the matched product
  via resultProducts below.

  v2 (2026-09-10): cut from 8 questions to 5 for completion rate. Kept the
  four highest signal questions (want, mushrooms, flavor, self) plus the
  goal question that personalizes the results and the email. Dropped
  ritual_style, moment and experience, and rewrote the insights so every
  one of them keys off a question that still exists.

  Every product claim here comes from the live product descriptions:
  - Original Hearts: cacao + six mushrooms + ancient spices, crash free
    energy with sustained focus, 200+ five star reviews, $50 / 20 servings
  - Elemental Hearts: cacao + six mushrooms, calm energy, sustained focus,
    inner balance, $50 / 20 servings
  - Eternal Bloom Rose: + organic rose petals and warming spices, calming
    uplifting energy, soft floral finish, $50 / 20 servings
  - Pure Discs: single origin heirloom white bean, Piura Peru, bright and
    fruity, no mushrooms or additives, $30
  If prices or products change, update resultProducts at the bottom.
*/
if (typeof window === 'undefined') { var window = {}; } /* Node test harness shim */
window.HMQ_QUIZ_CONFIG = {
  id: 'blend',
  version: 'v2',

  tracking: { prefix: 'BlendQuiz', metric: 'Blend Match Quiz Completed' },

  properties: {
    completed: 'blend_quiz_completed',
    score: 'blend_match_strength',
    archetype: 'blend_match',
    completedAt: 'blend_quiz_completed_at',
    version: 'blend_quiz_version'
  },

  /* Dimensions ARE the blends. Fit per blend lands on the Klaviyo profile. */
  dimensions: [
    { key: 'original', label: 'Original', weight: 0.25, property: 'blend_fit_original' },
    { key: 'elemental', label: 'Elemental', weight: 0.25, property: 'blend_fit_elemental' },
    { key: 'rose', label: 'Rose', weight: 0.25, property: 'blend_fit_rose' },
    { key: 'discs', label: 'Pure Discs', weight: 0.25, property: 'blend_fit_discs' }
  ],

  thresholds: {},

  /*
    Strongest normalized fit wins. Ties break toward Original (the
    flagship and easiest starting point), then Elemental, Rose, Discs.
  */
  archetypeRules: [
    { strongest: {
        order: ['original', 'elemental', 'rose', 'discs'],
        map: { original: 'original', elemental: 'elemental', rose: 'rose', discs: 'discs' }
      } }
  ],

  questions: [
    {
      id: 'wanting',
      save: 'blend_wanting',
      text: 'What do you most want from your daily cup?',
      answers: [
        { label: 'Steady energy and focus for the day', points: { original: 3, elemental: 2 } },
        { label: 'Calm and balance, more than a buzz', points: { elemental: 3, rose: 1 } },
        { label: 'A softer, heart centered pause', points: { rose: 3 } },
        { label: 'A deep, traditional cacao experience', points: { discs: 3 } }
      ]
    },
    {
      id: 'mushrooms',
      save: 'blend_mushroom_preference',
      text: 'How do you feel about functional mushrooms in your cacao?',
      answers: [
        { label: 'Love them, that is half the point', points: { original: 2, elemental: 2, rose: 2 } },
        { label: 'Curious, happy to try', points: { original: 2, elemental: 1, rose: 1 } },
        { label: 'I would rather keep it simple', points: { discs: 2 } },
        { label: 'No mushrooms for me', points: { discs: 3 } }
      ]
    },
    {
      id: 'flavor',
      save: 'blend_flavor_preference',
      text: 'Which flavor sounds most like you?',
      answers: [
        { label: 'Classic dark chocolate with ancient spices', points: { original: 3 } },
        { label: 'Pure cacao, bright and fruity, nothing added', points: { discs: 3 } },
        { label: 'Cacao with rose petals and warming spices', points: { rose: 3 } },
        { label: 'Smooth and clean, let the cacao speak', points: { elemental: 2, discs: 1 } }
      ]
    },
    {
      id: 'self',
      save: 'blend_self_description',
      text: 'Pick the phrase that sounds most like you right now:',
      answers: [
        { label: 'Driven and building, I need clean fuel', points: { original: 2, elemental: 1 } },
        { label: 'Overstimulated and craving calm', points: { elemental: 2, rose: 1 } },
        { label: 'Feeling first, soft and open', points: { rose: 3 } },
        { label: 'A purist, take me to the source', points: { discs: 3 } }
      ]
    },
    {
      id: 'primary_goal',
      save: 'blend_primary_goal',
      text: 'What would make this a win in 30 days?',
      answers: [
        { label: 'Less coffee, steadier energy', points: {}, goal: 'steady_energy' },
        { label: 'A daily ritual I actually keep', points: {}, goal: 'daily_ritual' },
        { label: 'Feeling calmer and more open', points: {}, goal: 'calm_open' },
        { label: 'A deeper connection to my practice', points: {}, goal: 'deeper_practice' }
      ]
    }
  ],

  archetypes: {
    original: {
      name: 'Original Blend Hearts',
      tagline: 'The daily anchor. Ceremonial cacao, six functional mushrooms and ancient spices, for clean, crash free energy with sustained focus.'
    },
    elemental: {
      name: 'Elemental Hearts',
      tagline: 'The calm one. Ceremonial cacao and six functional mushrooms, formulated for calm energy, sustained focus and inner balance.'
    },
    rose: {
      name: 'Eternal Bloom Rose Hearts',
      tagline: 'The soft one. Ceremonial cacao, six functional mushrooms, organic rose petals and warming spices, with a soft floral finish.'
    },
    discs: {
      name: 'Pure Ceremonial Cacao Discs',
      tagline: 'The purist cup. Single origin heirloom white bean cacao from Piura, Peru. No mushrooms, no additives, nothing but cacao.'
    }
  },

  /* Every insight keys off one of the five questions that still exist. */
  insights: [
    {
      id: 'wants_focus',
      when: { anyAnswer: [ { q: 'wanting', a: [0] }, { q: 'self', a: [0] } ] },
      title: 'You asked for steady energy',
      body: 'You want a cup that fuels the day without the spike and crash. The mushroom blends were built for exactly that: six adaptogenic mushrooms with ceremonial cacao for clean, sustained energy.'
    },
    {
      id: 'wants_calm',
      when: { anyAnswer: [ { q: 'wanting', a: [1] }, { q: 'self', a: [1] } ] },
      title: 'You are after calm, not a buzz',
      body: 'Balance matters more to you than intensity. That points away from stimulation and toward the gentler end of the range, where the lift stays quiet and steady.'
    },
    {
      id: 'wants_soft',
      when: { anyAnswer: [ { q: 'wanting', a: [2] }, { q: 'self', a: [2] } ] },
      title: 'You lead with the heart',
      body: 'You want your cup to feel like a pause, not a push. Rose petals and warming spices make Eternal Bloom the softest, most heart centered cup we make.'
    },
    {
      id: 'wants_depth',
      when: { anyAnswer: [ { q: 'wanting', a: [3] }, { q: 'self', a: [3] } ] },
      title: 'You want the source',
      body: 'You are drawn to cacao itself, not what gets added to it. Heirloom white bean cacao from Piura is about as close to the source as a cup gets.'
    },
    {
      id: 'mushroom_yes',
      when: { anyAnswer: [ { q: 'mushrooms', a: [0, 1] } ] },
      title: 'Mushrooms are welcome in your cup',
      body: 'All three heart blends carry the same six: Cordyceps, Lion Mane, Reishi, Chaga, Maitake and Golden Oyster. The blends differ in flavor and feel, not in the mushrooms.'
    },
    {
      id: 'mushroom_no',
      when: { anyAnswer: [ { q: 'mushrooms', a: [2, 3] } ] },
      title: 'You want cacao, full stop',
      body: 'The Pure Discs are cacao and nothing else. No mushrooms, no spices, no additives. Just single origin heirloom cacao, pre portioned and ready in about 30 seconds.'
    },
    {
      id: 'flavor_spice',
      when: { anyAnswer: [ { q: 'flavor', a: [0] } ] },
      title: 'Spice belongs in your cup',
      body: 'Ancient spices are what give Original its depth. It is the most classic, most chocolate forward cup in the range, and the one most people start with.'
    },
    {
      id: 'flavor_pure',
      when: { anyAnswer: [ { q: 'flavor', a: [1] } ] },
      title: 'You want nothing between you and the bean',
      body: 'Bright and fruity is exactly what heirloom white bean cacao from Piura tastes like. It is unusual, and it is the reason that region is prized.'
    },
    {
      id: 'flavor_floral',
      when: { anyAnswer: [ { q: 'flavor', a: [2] } ] },
      title: 'A softer flavor suits you',
      body: 'Organic rose petals and warming spices give Eternal Bloom a soft floral finish that opens up as the cup cools a little.'
    },
    {
      id: 'flavor_clean',
      when: { anyAnswer: [ { q: 'flavor', a: [3] } ] },
      title: 'Smooth and uncomplicated is the goal',
      body: 'No spices, nothing loud. Elemental keeps the cacao and the mushrooms and gets out of the way, which makes it the easiest cup to drink every day.'
    }
  ],

  fallbackInsight: {
    id: 'balanced_match',
    positive: true,
    title: 'You could be happy with more than one',
    body: 'Your answers spread across the range, which usually means the flagship is the right first bag. You can always follow your curiosity from there.'
  },

  /* "Your first cup" per blend. */
  firstShifts: {
    original: {
      title: 'Your first cup of Original',
      body: 'Tomorrow morning, drop one heart in a cup of hot water, froth for about 30 seconds, and take the first sip before you look at your phone. That is the whole ritual.'
    },
    elemental: {
      title: 'Your first cup of Elemental',
      body: 'Make your first cup on a slower morning. One heart, hot water, froth, and five unhurried minutes. Notice the calm underneath the lift.'
    },
    rose: {
      title: 'Your first cup of Eternal Bloom',
      body: 'Save your first cup for a soft moment: a slow morning or a quiet evening. One heart, hot water, froth, and let the rose open as it cools a little.'
    },
    discs: {
      title: 'Your first cup of the Pure Discs',
      body: 'Make your first cup a small ceremony. Six discs, water just below boiling, froth for about 30 seconds, and taste for the bright, fruity notes only Piura white bean cacao has.'
    }
  },

  goalLines: {
    steady_energy: 'You said the win is less coffee and steadier energy. Your match is built for exactly that swap.',
    daily_ritual: 'You said the win is a ritual you actually keep. Your match takes about 30 seconds a day.',
    calm_open: 'You said the win is feeling calmer and more open. Your match leans into exactly that.',
    deeper_practice: 'You said the win is a deeper practice. Your match will meet you there.'
  },

  /* Swapped into the results CTA by the engine. Prices as of 2026-09-09. */
  resultProducts: {
    original: {
      heading: 'Meet your blend',
      url: '/products/signature-blend-hearts',
      image: 'https://cdn.shopify.com/s/files/1/0910/9553/1885/files/AB4I2328.jpg?v=1765485486&width=520',
      alt: 'Original Blend Cacao Hearts',
      blurb: 'Ceremonial cacao, six functional mushrooms and ancient spices, pressed into 20 heart shaped servings. Ready in about 30 seconds. Use code ALIGNED10 for 10% off your first order.',
      cta: 'Shop Original Hearts',
      price_note: '$50.00 · 20 servings'
    },
    elemental: {
      heading: 'Meet your blend',
      url: '/products/elemental-hearts',
      image: 'https://cdn.shopify.com/s/files/1/0910/9553/1885/files/AB4I2338.jpg?v=1765485486&width=520',
      alt: 'Elemental Cacao Hearts',
      blurb: 'Ceremonial cacao and six functional mushrooms, formulated for calm energy and inner balance. 20 heart shaped servings, ready in about 30 seconds. Use code ALIGNED10 for 10% off your first order.',
      cta: 'Shop Elemental Hearts',
      price_note: '$50.00 · 20 servings'
    },
    rose: {
      heading: 'Meet your blend',
      url: '/products/eternal-bloom-rose-hearts',
      image: 'https://cdn.shopify.com/s/files/1/0910/9553/1885/files/AB4I2331.jpg?v=1765506712&width=520',
      alt: 'Eternal Bloom Rose Cacao Hearts',
      blurb: 'Ceremonial cacao, six functional mushrooms, organic rose petals and warming spices. 20 heart shaped servings with a soft floral finish. Use code ALIGNED10 for 10% off your first order.',
      cta: 'Shop Eternal Bloom Rose',
      price_note: '$50.00 · 20 servings'
    },
    discs: {
      heading: 'Meet your cacao',
      url: '/products/ceremonial-cacao-discs',
      image: 'https://cdn.shopify.com/s/files/1/0910/9553/1885/files/untitled-3.jpg?v=1765485546&width=520',
      alt: 'Pure Ceremonial Cacao Discs',
      blurb: 'Single origin heirloom white bean cacao from Piura, Peru. Pure, bright and fruity, with nothing added. Pre portioned discs, ready in about 30 seconds. Use code ALIGNED10 for 10% off your first order.',
      cta: 'Shop the Pure Discs',
      price_note: '$30.00 · pure single origin'
    }
  }
};

/* Node test harness support (never true in the browser). */
if (typeof module !== 'undefined' && module.exports) {
  module.exports = window.HMQ_QUIZ_CONFIG;
}